import { EndConversationConfirmModalLazy } from '@liveHelper/components/Chatting/EndConversationConfirmModal'
import { StreamSettingModalLazy } from '@liveHelper/components/SettingsModal/SettingsModalLazy'

import { registerModals } from '@core/modal/model/registerModals'

export const { getModalComponent, selectors, createSlice } = registerModals({
  settings: StreamSettingModalLazy,
  endConversationConfirm: EndConversationConfirmModalLazy,
})
